import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight } from 'lodash/fp';
import { change, formValues } from 'redux-form';
import FormGroup from '../../../form/Group';
import GridRadioGroup from '../../../form/GridRadioGroup';
import GridRadioButton from '../../../form/GridRadioButton';
import { TextField } from '../../../form/field';
import RadioQuestion from '../../../InvestorProfile/RadioQuestion';
import getSettings from '../../../../common/utils/settings';
import './ManagementAct.scss';

const Creation = ({ dispatch, compagnyChoice }) => {
    const managementAct = getSettings('simulation.managementAct');

    useEffect(() => {
        const formName = 'contact-creation';
        dispatch(change(formName, 'operationType', 'versement'));
    }, [dispatch]);

    const companies = [];
    if (managementAct) {
        Object.keys(managementAct).forEach((key) => {
            const company = managementAct[key];
            if (!company.deleted) {
                companies.push({
                    key,
                    name: company.name.toUpperCase(),
                    disabled: !company.referrerCode || '' === company.referrerCode.trim(),
                });
            }
        });
    }

    return (
        <div className="management-act-creation-form">
            <FormGroup title="Sélectionner le fournisseur">
                <GridRadioGroup name="compagnyChoice" >
                    {companies.map((company) => (
                        <GridRadioButton
                            key={company.key}
                            value={company.key}
                            label={company.name}
                            disabled={company.disabled}
                        />
                    ))}
                </GridRadioGroup>
            </FormGroup>

            {compagnyChoice &&
                <Fragment>
                    <RadioQuestion
                        choices={{
                            versement: 'Versement',
                        }}
                        name="operationType"
                        title="Sélectionner le type d'opération"
                    />

                    <TextField
                        name="contractNumber"
                        title="Saisir le numéro de contrat"
                        required
                    />
                </Fragment>
            }
        </div>
    );
};

Creation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    compagnyChoice: PropTypes.string,
};

Creation.defaultProps = {
    compagnyChoice: null,
};

export default flowRight([
    connect(),
    formValues({ compagnyChoice: 'compagnyChoice' }),
])(Creation);
export { default as formValidate } from './formValidate';
